var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42315 17.9167C4.00217 17.9167 3.64585 17.7708 3.35419 17.4792C3.06252 17.1875 2.91669 16.8312 2.91669 16.4102V5.25647C2.91669 4.8355 3.06252 4.47918 3.35419 4.18751C3.64585 3.89585 4.00217 3.75001 4.42315 3.75001H5.5769V1.9873H6.85898V3.75001H13.1731V1.9873H14.4231V3.75001H15.5769C15.9979 3.75001 16.3542 3.89585 16.6459 4.18751C16.9375 4.47918 17.0834 4.8355 17.0834 5.25647V16.4102C17.0834 16.8312 16.9375 17.1875 16.6459 17.4792C16.3542 17.7708 15.9979 17.9167 15.5769 17.9167H4.42315ZM4.42315 16.6667H15.5769C15.6411 16.6667 15.6998 16.6399 15.7531 16.5865C15.8066 16.5331 15.8334 16.4744 15.8334 16.4102V8.5898H4.16669V16.4102C4.16669 16.4744 4.19342 16.5331 4.2469 16.5865C4.30023 16.6399 4.35898 16.6667 4.42315 16.6667Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIc);
export default __webpack_public_path__ + "static/media/CalenderIc.8f0c114c552be0d4a88298f3da1e67ee.svg";
export { ForwardRef as ReactComponent };